import {
  sampleChatgptMarkdown,
  sampleGeminiMarkdown,
  sampleMarkdown,
  sampleMermaidMarkdown,
  sampleReadmeMarkdown,
  sampleTechResumeMarkdown,
} from "@/app/_components/editor/constants";

/** Embedded converters that ship a build-time Paged.js preview snapshot. */
export const samplePreviewIds = [
  "home",
  "resume",
  "readme",
  "chatgpt",
  "gemini",
  "mermaid",
] as const;

export type SamplePreviewId = (typeof samplePreviewIds)[number];

export type SamplePreviewDefinition = {
  id: SamplePreviewId;
  markdown: string;
};

/** Seed markdown for each embedded sample preview (homepage + intent pages). */
export function getSamplePreviewDefinitions(): readonly SamplePreviewDefinition[] {
  return [
    { id: "home", markdown: sampleMarkdown },
    { id: "resume", markdown: sampleTechResumeMarkdown },
    { id: "readme", markdown: sampleReadmeMarkdown },
    { id: "chatgpt", markdown: sampleChatgptMarkdown },
    { id: "gemini", markdown: sampleGeminiMarkdown },
    { id: "mermaid", markdown: sampleMermaidMarkdown },
  ];
}
